import angular from "angular";

export default angular.module("energis.help", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("help", {
    url: "/napoveda",
    template: require("./help.html"),
  })
})
.name;


// WEBPACK FOOTER //
// ./src/Help/index.js